import { render, staticRenderFns } from "./AddPhotoModal.vue?vue&type=template&id=3918cdfd"
import script from "./AddPhotoModal.vue?vue&type=script&lang=js"
export * from "./AddPhotoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports